/**
 * Held items registry index
 */
import { vietnamese_held_builders } from './vietnamese.js';
import { weapons_held_builders } from './weapons.js';
import { tools_sports_held_builders } from './tools-sports.js';

export const HELD_ITEMS_REGISTRY = {
  ...vietnamese_held_builders,
  ...weapons_held_builders,
  ...tools_sports_held_builders
};
